function initBook() {
  const bookItems = document.querySelectorAll('.book-item');
  const tip = document.querySelector('.next-tip');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');

  if (!bookItems.length || !nextBtn || !prevBtn) {
    console.log('book not ready, retry...');
    setTimeout(initBook, 300);
    return;
  }

  let currentPage = 0;
  let isAnimating = false;
  const pageTotal = bookItems.length;

  function switchPage(targetPage) {
    if (isAnimating || targetPage < 0 || targetPage >= pageTotal) return;
    isAnimating = true;

    bookItems[currentPage].classList.remove('active');
    currentPage = targetPage;
    bookItems[currentPage].classList.add('active');

    setTimeout(() => isAnimating = false, 300);
  }

  nextBtn.onclick = () => switchPage(currentPage + 1);
  prevBtn.onclick = () => switchPage(currentPage - 1);

  console.log('book init success');

  // ========== 手机端双指缩放 + 单指拖动（直接作用在图片上） ==========
  const isMobile = window.innerWidth < 768;
  if (!isMobile) return;

  const images = document.querySelectorAll('.img-mob');
  images.forEach(img => {
    let scale = 1;
    let translateX = 0;
    let translateY = 0;
    let startX1 = 0, startY1 = 0;
    let startX2 = 0, startY2 = 0;
    let initialDistance = 0;
    let initialScale = 1;

    // 重置变换
    function applyTransform() {
      img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale})`;
    }

    // 计算两点距离
    function getDist(t1, t2) {
      return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
    }

    img.addEventListener('touchstart', e => {
      e.preventDefault();
      const touches = e.touches;
      if (touches.length === 1) {
        // 单指：记录拖动起点
        startX1 = touches[0].clientX - translateX;
        startY1 = touches[0].clientY - translateY;
      } else if (touches.length === 2) {
        // 双指：记录缩放起点
        const t1 = touches[0];
        const t2 = touches[1];
        startX1 = t1.clientX;
        startY1 = t1.clientY;
        startX2 = t2.clientX;
        startY2 = t2.clientY;
        initialDistance = getDist(t1, t2);
        initialScale = scale;
      }
    });

    img.addEventListener('touchmove', e => {
      e.preventDefault();
      const touches = e.touches;
      if (touches.length === 1) {
        // 单指拖动
        translateX = touches[0].clientX - startX1;
        translateY = touches[0].clientY - startY1;
        applyTransform();
      } else if (touches.length === 2) {
        // 双指缩放
        const t1 = touches[0];
        const t2 = touches[1];
        const newDist = getDist(t1, t2);
        scale = Math.max(1, Math.min(5, initialScale * (newDist / initialDistance)));
        applyTransform();
      }
    });

    img.addEventListener('touchend', e => {
      // 可选：松开双指后保持缩放，不重置
    });
  });
}

initBook();